import { StyleSheet } from 'react-native';
import {
    JDDevice,
    JDTouchable,
} from '@jdreact/jdreact-core-lib';
import { pt, px } from '../common/utils';

const st = StyleSheet.create({
    container: {
        backgroundColor: '#F7F7F7',
        width: pt(375),
        position: 'absolute',
        top: 0,
        bottom: 0
    },
    
    //top
    top: {
        paddingHorizontal: pt(10),
        backgroundColor: '#fff',
        borderBottomWidth: px(2),
        borderColor: '#0001',
        height: pt(73),
        paddingTop: pt(12)
    },
    top_new: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        paddingHorizontal: pt(10),
        backgroundColor: '#fff',
        borderBottomWidth: px(2),
        borderColor: '#0001',
        height: pt(73),
        paddingTop: pt(0),
    },
    top_l: {
        width: pt(220),
        alignItems: 'flex-start'
    },
    top_r: {
        width: pt(125),
        fontSize: pt(12),
        alignItems: 'flex-end'
    },
		mov_name: {
			color: '#000',
			fontSize: pt(16),
			paddingTop: pt(5)
		},
		mov_name_start: {
			color: '#000',
			fontSize: pt(16),
			paddingTop: pt(5),
			fontWeight: "600"
		},
		mov_info: {
			color: '#666',
			fontSize: pt(12),
			paddingTop: pt(5)
		},
    wrap_tip: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    tip_img: {
        height: pt(13),
        width: pt(13)
    },
    tip_txt: {
        color: '#252525',
        fontSize: pt(10),
        marginRight: pt(20),
        marginLeft: pt(5)
    },
    // bottom
    wrap_bottom: {
        backgroundColor: '#fff',
        zIndex: '4'
    },

    tel_title: {
        color: '#898989',
        fontSize: pt(12),
        marginHorizontal: pt(10)
    },
    tel_input: {
        flex: 1,
        marginRight: pt(50),
        height: pt(32),
        marginVertical: pt(9),
        padding: 0,
        paddingLeft: pt(10),
        borderWidth: 0,
        borderRadius: pt(2),
        backgroundColor: '#F5F7F8',
        fontSize: pt(16),
        color: '#252525'
    },
    clear_input: {
        position: 'absolute',
        right: pt(50),
        padding: pt(10)
    },
    clear_input_img: {
        height: pt(14),
        width: pt(14)
    },

    recom: {
        height: pt(60),
        alignItems: 'center',
        width: pt(375),
        flexDirection: 'row',
        position: 'relative'
    },
    recom_item: {
        marginRight: pt(10),
        borderColor: '#E6E8E9',
        height: pt(26),
        width: pt(42),
        backgroundColor: '#F5F7F8',
        borderRadius: pt(5),
        justifyContent: 'center',
        alignItems: 'center'
    },
    recom_item_txt: {
        color: '#252525',
        fontSize: pt(12)
    },
    recom_title: {
        color: '#252525',
        fontSize: pt(12),
        marginHorizontal: pt(10)
    },

    has_sel: {
        height: pt(60),
        justifyContent: 'flex-end',
        width: pt(375),
        backgroundColor: '#fff'
    },
    sel_title: {
        color: '#898989',
        fontSize: pt(12),
        marginLeft: pt(10)
    },
    wrap_has_item: {
        marginTop: pt(3),
        flexDirection: 'row'
    },
    mb9: {
        marginBottom: pt(9)
    },
    has_item: {
        height: pt(35),
        width: pt(76),
        backgroundColor: '#F5F7F8',
        marginLeft: pt(8),
        borderRadius: pt(4),
        paddingLeft: pt(8),
        justifyContent: 'center',
        position: 'relative'
    },
    seat_text: {
        color: '#252525',
        fontSize: pt(12)
    },
    pri_text: {
        color: '#E2231A',
        fontSize: pt(12)
    },
    del_seat_text: {
        position: 'absolute',
        right: pt(5),
        top: -pt(5),
        color: '#666',
        fontSize: pt(10)
    },

    wrap_promotion: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    wrap_promotion_txt: {
        borderRadius: pt(2),
        height: pt(12),
        width: pt(12),
        // backgroundColor: '#4D88FF',
        backgroundColor: '#F56A00',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: pt(2)
    },
    greenWrapPromotionTxt: {
        backgroundColor: '#0AAD48',
    },
    promotion_txt: {
        fontSize: pt(8),
        color: '#fff'
    },

    // sub
    wrap_sub: {
        height: pt(50),
        opacity: 0.5
    },
    sub: {
        height: pt(50),
        justifyContent: 'center',
        alignItems: 'center',
        width: pt(375)
    },
    sub_txt: {
        color: '#fff',
        fontSize: pt(16)
    },

    // wrap_seat
    wrap_seat: {
        flex: 1,
        overflow: 'auto',
        position: 'relative',
        flexDirection: 'column',
        // paddingHorizontal:pt(20)
        // marginBottom:pt(100)
    },

    seat_bg: {
        alignItems: 'center',
        zIndex: 2,
        padding: pt(10),
        paddingTop: 0,
        paddingBottom:pt(5)
    },

    seat_bg_img: {
        width: pt(160),
        height: pt(16),
        zIndex: 0
    },

    bg_text: {
        fontSize: pt(12),
        color: '#252525',
        backgroundColor: '#0000',
        width: pt(160),
        textAlign: 'center',
        position: 'absolute',
        top: 0,
        zIndex: 1
    },

    center_line: {
        position: 'absolute',
        borderRightWidth: pt(1),
        borderColor: '#e2e2e2',
        borderStyle: 'dotted',
        left: '50%',
        top: pt(45),
        bottom: pt(25)
    },

    srap_line: {
        flexDirection: 'row',
        flexWrap: 'nowrap'
    },
    seat_img: {
        height: pt(14),
        width: pt(14),
        marginRight: pt(2),
        marginBottom: pt(2),
        backgroundColor: '#fff',
        borderRadius: pt(1)
    },
    db_img: {
        width: pt(30),
    },
    wrap_line: {
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
        // zIndex: -2
        zIndex: 0,
        paddingRight: pt(20),
        // paddingLeft:pt(20),
		    // overflow: 'auto'
    },

    wrap_rect: {
        alignItems: 'center',
        position: 'relative',
        marginLeft: pt(85)
        // padding: pt(40),
        // paddingHorizontal: pt(20)
    },

    best: {
        position: 'absolute'
    },

    seat_num: {
        width: pt(14),
        backgroundColor: 'rgba(0, 0, 0, 0.533)',
        zIndex: -1,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: pt(10),
        overflow: 'hidden'
    },
    wrap_seat_num: {
        alignItems: 'center',
        justifyContent: 'center'
    },
    num_item: {
        color: '#fff',
        fontSize: pt(11),
        alignItems: 'center',
        justifyContent: 'center'
    },

    gif: {
        position: 'absolute',
        width: pt(14.5),
        height: pt(14),
        zIndex: 3,
        alignSelf: 'flex-start',
        backgroundColor: '#222'
    },

    wrap_confirm_text: {
        minHeight: pt(70),
        paddingHorizontal: pt(10),
        justifyContent: 'center'
    },
    wrap_alert_text: {
        minHeight: pt(20),
        paddingHorizontal: pt(10),
        justifyContent: 'center'
    },
    confirm_text: {
        color: '#232326',
        textAlign: 'center',
        fontSize: pt(14)
    },

    wrap_loading: {
        position: 'absolute',
        height: '100%',
        width: pt(375),
        alignItems: 'center',
        justifyContent: 'center'
    },
    loading_con: {
        height: pt(85),
        width: pt(85),
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        borderRadius: pt(8),
        alignItems: 'center',
        justifyContent: 'center'
    },
    loading_img: {
        height: pt(50),
        width: pt(50)
    },
    loading_text: {
        color: '#fff',
        fontSize: pt(14)
    },
    rz_contain: {
        height: pt(27),
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginLeft: pt(10),
        marginRight: pt(13),
        borderBottomColor: '#F2F2F2',
        borderBottomWidth: pt(1)
    },
    box_row: {
        flexDirection: 'row'
    },
    img_smrz: {
        width: pt(16),
        height: pt(16)
    },
    img_right:{
        width:pt(5),
        height:pt(9)
    },
    align_center: {
        justifyContent:'center',
        flexWrap:'wrap',
        flexDirection: 'row',
        width: JDDevice.width
    },
    // 遮挡颜色设置
    bgt_color: {
        backgroundColor: '#F7F7F7',
        width: JDDevice.width
    },
    fast: {
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: pt(12),
        marginTop: pt(12),
        height: pt(14)
    },
    fast_img: {
        width: pt(13),
        height: pt(13),
        marginRight: pt(4)
    }
});




export default st;